import PubSub from 'pubsub-js';
import { PaymentSettings } from './types';

export const PAYMENT_METHOD_CHANGED_EVENT_ID = Symbol('7T:Payments.MethodChanged');

export const paymentMethodChangedEventPubSub: PubSubJS.Base<
PaymentSettings,
  typeof PAYMENT_METHOD_CHANGED_EVENT_ID
> = PubSub;
